export enum EBitfTouchEventType {
  UP = 'UP',
  DOWN = 'DOWN',
}
